import { render, staticRenderFns } from "./ResultMessage.vue?vue&type=template&id=7e4f1e87&"
import script from "./ResultMessage.vue?vue&type=script&lang=js&"
export * from "./ResultMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports